import { useState, useEffect } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { ISearchPage } from '@/types/FmsTypes'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from '@/utils/constants'
import { transPgToPagination } from '../../../../base/app/appModel'
import { IAccountSummary, ICustomerAccountSummary, ICustomerMergeItem, ICustomerMergePageSearch } from '../../../AccountTypes'
import { IMdCustomerFields } from '../../../../base/customer/customerService'
import { useGlobalModel } from '@/model/globalModel'
import { accountShopService } from '@/views/account/AccountShopService'
import { accountService } from '@/views/account/AccountService'
import { message } from 'antd'
import { convertRes2Blob } from '@/utils/exportFile'

interface IMergerInfo {
    visible: boolean
    id?: string
    mode?: 'add' | 'edit'
}

export const useMergerModel = createModel(function () {
    const {
        user: { shopCode },
    } = useGlobalModel()
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IMdCustomerFields>({})
    //列表数据源
    const [dataSource, setDataSource] = useState<ICustomerMergeItem[]>([])

    const [summaryData, setSummaryData] = useState<IAccountSummary>({})
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<ICustomerMergeItem[]>([])
    const [selectedData, setSelectedData] = useState<ICustomerMergeItem>()
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)

    //切换门店清除缓存
    useEffect(() => {
        setDataSource([])
        setSelectedRowKeys([])
    }, [shopCode])

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IMdCustomerFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSelectedRowKeys([])
        setSearchParam({})
        loadData(initPgCfg, {})
    }
    const clearSelectData = () => {
        setSelectedRowKeys([])
        setSelectedData(undefined)
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchVlaue: IMdCustomerFields = searchParam) => {
        const searchParams = {
            ...defaultMdCmParam,
            ...searchVlaue,
            shopCode,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            },
        }
        let { retData } = await accountService.customerMergePage(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(records)

        let { retData: summaryData } = await accountShopService.customerSummary(searchParams)
        setSummaryData(summaryData)
        clearSelectData()
    }

    const getSelectedData = () => {
        return selectedData
    }

    //客户合并弹窗
    const [mergerInfo, setMergerInfo] = useState<IMergerInfo>({visible: false})
    const onAddMerger = () => {
        setMergerInfo({ mode: 'add', visible: true })
    }

    const editCustomerMerger = (record: ICustomerMergeItem) => {
        setMergerInfo({visible: true, mode: 'edit', id: record.id})
    }
    
    const deleteCustomerMerger = (id: string) => {
        accountService.customerMergeDelete(id).then(res => {
            if(res && res.retData){
                message.success("解除成功")
            }
            loadData()
        })
    }



    //客户账单导出
    const customerMergerExport = async () => {
        const searchParams: ICustomerMergePageSearch = {
            ...defaultMdCmParam,
            ...searchParam,
            shopCode,
            page: {
                pageSize: -1,
                pageNum: 1,
            },
        }
        let result = await accountService.customerMergeExport(searchParams);
        convertRes2Blob(result);
    }

    return {
        /***field***/
        initPgCfg,
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        summaryData,
        setSelectedData,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        getSelectedData,
        onAddMerger,
        mergerInfo, setMergerInfo,
        editCustomerMerger, deleteCustomerMerger,
        customerMergerExport,
        setSearchParam
    }
})
